export default "__VITE_ASSET__4e48efcb__"